<div class="department-management-container">
  <div class="header">
    <h2>Department Management</h2>
    <button class="btn btn-primary" (click)="openAddDepartmentModal()">
      <fa-icon [icon]="addIcon"></fa-icon>
      Add New Department
    </button>
  </div>

  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let department of departments">
          <td>{{ department.id }}</td>
          <td>{{ department.name }}</td>
          <td>
            <span class="status-badge" [class.active]="department.status === 1">
              {{ department.status === 1 ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td class="actions">
            <button class="action-button edit" (click)="editDepartment(department)">
              <fa-icon [icon]="editIcon"></fa-icon>
            </button>
            <button class="action-button status" (click)="toggleStatus(department)">
              {{ department.status === 1 ? 'Deactivate' : 'Activate' }}
            </button>
          </td>
        </tr>
        <tr *ngIf="departments.length === 0">
          <td colspan="4" class="text-center">No departments added yet.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Department Modal -->
  <div class="modal" *ngIf="showDepartmentModal">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ editingDepartment ? 'Edit Department' : 'Add New Department' }}</h3>
        <button class="close-button" (click)="closeDepartmentModal()">&times;</button>
      </div>
      <form [formGroup]="departmentForm" (ngSubmit)="saveDepartment()">
        <div class="form-group">
          <label for="name">Name</label>
          <input 
            type="text" 
            id="name"
            formControlName="name" 
            placeholder="Enter department name"
            [ngClass]="{'is-invalid': departmentForm.get('name')?.invalid && departmentForm.get('name')?.touched}"
          >
          <div class="invalid-feedback" *ngIf="departmentForm.get('name')?.invalid && departmentForm.get('name')?.touched">
            Department name is required.
          </div>
        </div>
        <div class="form-group">
          <label for="status">Status</label>
          <select id="status" formControlName="status">
            <option [value]="1">Active</option>
            <option [value]="0">Inactive</option>
          </select>
        </div>
        <div class="modal-footer">
          <button type="button" class="cancel-button" (click)="closeDepartmentModal()">Cancel</button>
          <button type="submit" class="save-button" [disabled]="departmentForm.invalid">
            {{ editingDepartment ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div> 